import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/orders/missing')({
  staticData: {
    title: 'route.orders.missing',
    crumb: 'route.orders.missing',
    permissions: ['customers_stores_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
